import { Tooltip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function NormalSideBarItem({
  title,
  linkTo,
  isActiveLink,
  isOpenSidebar,
  normalIcon,
  selectedIcon,
  onClick,
}) {
  return (
    <Tooltip
      title={isOpenSidebar ? "" : title}
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            textTransform: "capitalize"
          }
        }
      }}
    >
      <Link onClick={onClick} className={`mt-s16`} to={linkTo}>
        <div
          className={`flex items-center h-s50 transition-all duration-300
           ${isActiveLink === true
              ? "bg-cBrand text-white"
              : "bg-cSidebarDarkBg text-cSidebarText"
            }  
     ${isOpenSidebar ? "pl-s5  rounded-full" : "justify-center w-20"}
    `}
        >
          <div
            className={`flex justify-center items-center rounded-full transition-all duration-300 w-s30 h-s30 
             ${isActiveLink === true ? "bg-cWhite" : "bg-cSidebarDarkBg "} ${isOpenSidebar ? "my-s7 ml-s7" : ""
              }`}
          >
            <img
              className=" w-s15 h-s16 object-cover"
              src={isActiveLink === true ? selectedIcon : normalIcon}
              alt=""
            />
          </div>
          {isOpenSidebar ? (
            <div className="font-semibold pl-5 text-fs14 text-left capitalize">
              {title}
            </div>
          ) : (
            ""
          )}
        </div>
      </Link>
    </Tooltip>
  );
}
